import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppComponent} from './app.component';
import {HeaderDetailComponent} from './components/header-detail/header-detail.component';
import {AppRoutingModule} from './app-routing.module';
import { SubDetailComponent } from './components/sub-detail/sub-detail.component';
import { AppDetailComponent } from './components/app-detail/app-detail.component';
import { IconModule } from 'src/app/shared/components/icon/icon.module';


@NgModule({
  declarations: [
    AppComponent,
    HeaderDetailComponent,
    SubDetailComponent,
    AppDetailComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    IconModule,
  ],
  exports: [AppComponent]
})
export class AppModule {
}
